import styled from 'styled-components';

export const Card = styled.div`
  color: #3e3a83;
  border: 1px solid #d9d5f9;
  border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  padding: 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #d9d5f9;
  background-color: #f5f4fe;
`;

export const CardContent = styled.div`
  padding: 20px;
`;
